import React, { useState } from 'react';

const STAGING_HOSTS = ['staging.winbit32.com', 'dev.winbit32.com'];

const StagingBanner = () => {
	const [dismissed, setDismissed] = useState(false);

	if (typeof window === 'undefined') return null;

	const hostname = window.location.hostname;
	const isStaging = STAGING_HOSTS.includes(hostname) ||
		(hostname.endsWith('.winbit32.com') && hostname !== 'winbit32.com' && hostname !== 'www.winbit32.com');

	if (!isStaging || dismissed) return null;

	return (
		<div style={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			zIndex: 999999999,
			background: 'repeating-linear-gradient(45deg, #ff8c00, #ff8c00 10px, #ff6600 10px, #ff6600 20px)',
			color: '#fff',
			textAlign: 'center',
			padding: '4px 12px',
			fontFamily: 'MS Sans Serif, Tahoma, sans-serif',
			fontSize: '12px',
			fontWeight: 'bold',
			textShadow: '1px 1px 1px rgba(0,0,0,0.5)',
			borderBottom: '2px solid #c44000',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '8px',
		}}>
			<span>
				PREVIEW BUILD ({hostname}) &mdash; This is not a release version and may contain bugs.
				Use <a href="https://winbit32.com" style={{ color: '#fff', textDecoration: 'underline' }}>winbit32.com</a> for production.
			</span>
			<button
				onClick={() => setDismissed(true)}
				style={{
					background: 'rgba(0,0,0,0.3)',
					border: '1px solid rgba(255,255,255,0.4)',
					color: '#fff',
					padding: '1px 8px',
					cursor: 'pointer',
					fontSize: '10px',
					borderRadius: '2px',
				}}
			>
				OK
			</button>
		</div>
	);
};

export default StagingBanner;
